/* eslint-disable max-len */
import React from 'react';
import style from './index.module.scss';
interface Props {
  lang: any;
  total: number;
  currency: 'Rp' | 'Rs' | '';
  start: number;
  end: number;
  hasRule: boolean;
  bridge?: any;
  hasNotice?: boolean;
}
function format(time: number) {
  const date = new Date(time);
  return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
}
export default function WeeklyHead({ lang, total, currency, start, end, hasRule, bridge, hasNotice }: Props) {
  function goToRule() {
    bridge?.loadUrlOnNewPage({
      url: 'https://m.snackvideo.com/pbact/5/2021/earn_cash_every_week',
      type: 'back',
    });
  }
  return (
    <div className={`${style.head} ${hasNotice ? style.hasNotice : ''}`}>
      <div className={`${style.title} ${lang.weekly_title?.length > 25 ? style.small : ''}`} dangerouslySetInnerHTML={{ __html: lang.weekly_title?.replace('${0}', `<span>${currency} ${(+total).toLocaleString()}</span>`) }}></div>
      <div className={style.time}>{format(start)}-{format(end)}</div>
      {hasRule ? <div className={style.btn} onClick={goToRule}>{lang.newyear_58441?.replace(':', '').replace('：', '')}</div> : null}
    </div>
  );
}
